function makeObject(locale) {
  // These were the languages available for these buttons 12/16/21. Leaving some empty so you can see which languages we checked for.
  // const neither = ['ceb', 'fj', 'ht', 'sm', 'tl', 'to', 'vi']

  const androidOnly = [
    'da',
    'el',
    'et',
    'hr',
    'hy',
    'is',
    'km',
    'mk',
    'mn',
    'ms',
    'sl',
    'sq',
    'sr',
    'sv',
    'uk',
    'zh-hans',
    'zh',
  ]
  const iosOnly = ['fi']
  const both = [
    'bg',
    'cs',
    'de',
    'en',
    'es',
    'fr',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'lv',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'th',
    'tr',
    'zh-hans',
    'zh',
  ]
  const iosOverrides = [
    { lang: 'fi', width: '142.9' },
    { lang: 'fr', width: '126.5' },
    { lang: 'hu', width: '150.7' },
    { lang: 'ja', width: '108.9' },
    { lang: 'ko', width: '129.7' },
    { lang: 'tr', width: '151.3' },
    { lang: 'zh-hans', width: '108.9' },
    { lang: 'zh', width: '108.9' },
  ]
  const capLocale = locale === 'zh-hans' ? 'ZhHans' : locale.charAt(0).toUpperCase() + locale.slice(1)

  return Promise.all([
    both.includes(locale) || iosOnly.includes(locale)
      ? import(`./assets/app-store/Ios${capLocale}.js`)
      : import(`./assets/app-store/IosEn.js`),
    both.includes(locale) || androidOnly.includes(locale)
      ? import(`./assets/play-store/Android${capLocale}.js`)
      : import(`./assets/play-store/AndroidEn.js`),
  ])
    .then(([IosImg, AndroidImg]) => {
      const widthFound = iosOverrides.find((obj) => obj.lang === locale)
      const imgObj = {
        ios: {
          image: IosImg.default,
          widthOverride: widthFound ? widthFound.width : undefined,
        },
        android: {
          image: AndroidImg.default,
        },
      }
      return imgObj
    })
    .catch((error) => {
      console.error(error)
    })
}

export default function getMobileAppInfo(locale, type) {
  return makeObject(locale)
    .then((imgObj) => {
      return type === 'ios' ? imgObj.ios : imgObj.android
    })
    .catch((error) => {
      console.error(error)
    })
}
